import React from 'react';
import { Link } from "react-router-dom";
import { FaBagShopping } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { FaBorderAll } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { useTranslation } from 'react-i18next';




function Myaddress() {
  const { t } = useTranslation();

  
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
   <div><main className="page-content">
    <div className="tm-section tm-my-account-area bg-white tm-padding-section profile-men wishlist-section-ones">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4"> 
            <div className="tm-myaccount tm-myaccount-fives">
              <div className="my-profile-left">
                <img src="assets/images/user-photo.png" />
                <h2> {t("MO8")} </h2>
                <p>+91 9999999999</p>
              </div>
              <ul className="nav tm-tabgroup tabgroup-left1">
                    <li className="nav-item">
                     

                      <Link to="/Myprofile" className="nav-link ">
                      <FaBagShopping /> {t("MO1")}
                      </Link>

                   
                    </li>
                    <li className="nav-item">
                    <Link to="/Myorder" className="nav-link " onClick={handleLinkClick}> 
                    <FaBorderAll />  {t("MO14")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Myaddress" className="nav-link active ">
                        <i className="fas fa-map-marker-alt me-2" />  {t("MO2")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Mywishlist" className="nav-link ">
                      <FaHeart />   {t("MO3")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Login" className="nav-link ">
                      <LuLogOut />  {t("MO4")}
                      </Link>
                    </li>
                  </ul>
            </div>
          </div>
          <div className="col-lg-9 col-md-8">
            <div className="my-profile-right">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                
                </div>
                <div className="col-lg-6 col-md-6 mt-30 mt-md-0 address-my-profile">
                  
                </div>
                <div className="col-lg-12">
                  <div className="col-lg-4" style={{margin: '0 auto'}}>
                    <div className="address-men-btn">
                      <button type="button" className="tm-button tm-button-dark" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      {t("A7")}
                      </button>
                      {/* Modal */}
                      <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-scrollable">
                          <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t("A8")}</h5>

                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                      <div className="cart-box1 cart-box11">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <div className="cart-box5">
                                              <div className="row">
                                                <div className="col-lg-12">
                                                  <div className="cart-text cart-text1 cart-text12">
                                                    <form className="full-form">
                                                      <h2><span> {t("A9")}</span></h2>
                                                      <div className="row">
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A28")} />
                                                        </div>
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A29")} />
                                                        </div>
                                                      </div>
                                                      <h2><span> {t("A10")}</span></h2>
                                                      <div className="row">
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A30")}  />
                                                        </div>
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A31")}  />
                                                        </div>
                                                        <div className="col-lg-12 col-md-6">
                                                          <input className="card-form" type="text" placeholder={t("A32")}  />
                                                        </div>
                                                      </div>
                                                      <div className="form-twobutton">
                                                        <div className="form-left">
                                                          <label>{t("A11")}</label>
                                                        </div>
                                                        <div className="form-left">
                                                          <label>{t("A12")}</label>
                                                        </div>
                                                      </div>
                                                      <h2><span> {t("A13")}</span></h2>
                                                      <div className="address-btn">
                                                        <div className="address-btn1">
                                                        {t("A14")}
                                                        </div>
                                                        <div className="address-btn1">
                                                        {t("A15")}
                                                        </div>
                                                      </div><br />
                                                      <div className="check-boxbtn check-boxbtn-aa">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" defaultValue="Bike" />
                                                        <label htmlFor="vehicle1"> {t("A16")}</label>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="cart-text cart-text1 cart-text12">
                                        <a href="#">
                                          <div className="add-new-address add-new-address11 text-center">{t("A17")}</div>
                                        </a>
                                      </div>
                                    </div>
                          </div>
                        </div>
                      </div>
                      {/* Modal */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main></div>

  )
}

export default Myaddress